export /**
 * Extract error messages from API error
 */
const getErrorMessages = (error: any): string[] => {
  // Check for Laravel validation errors
  if (error?.response?.data?.errors) {
    const validationErrors = error.response.data.errors;
    const errorMessages: string[] = [];

    // Laravel returns errors as an object with field names as keys
    // and arrays of error messages as values
    Object.keys(validationErrors).forEach(field => {
      const fieldErrors = validationErrors[field];
      if (Array.isArray(fieldErrors)) {
        fieldErrors.forEach(msg => {
          // Format: "Field Name: Error message"
          const formattedField = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
          errorMessages.push(`${formattedField}: ${msg}`);
        });
      }
    });

    if (errorMessages.length > 0) {
      return errorMessages;
    }
  }

  // Fallback to generic error message
  const message = error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    'Failed to save duty configuration. Please try again.';

  return [message];
};